import React, { ChangeEvent, FormEvent, useCallback, useState } from 'react'
import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { iDeliveryLocation } from '../types';


interface ShippingAddressProps {
    payload: iDeliveryLocation;
    handleModal: (toggle: boolean) => void;
    handleLocationSetter: (deliveryLocation: iDeliveryLocation) => void;
}

export const ShippingAddress = ({payload, handleModal, handleLocationSetter}: ShippingAddressProps) => {

    const states = (process.env.REACT_APP_STATE_DROPDOWN || "").split(",");
    const [errors, setErrors] = useState<string>("");

    const [deliveryLocation, setDeliveryLocation] = useState<iDeliveryLocation>(payload ? {
        country: 'Nigeria',
        defaults: true,
        heading: 'Home',
        ...payload
    } : {
        defaults: true,
        country: 'Nigeria',
        heading: 'Home',
    });

    const handleShippingAddressSubmission = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!deliveryLocation.state) {
            setErrors('Please select delivery state to continue.');
            return ;
        }

        if (!deliveryLocation.firstName){
            setErrors('Please enter contact person first name to continue.');
            return ;
        }
        
        if (!deliveryLocation.lastName){
            setErrors('Please enter contact person last name to continue.');
            return ;
        }
       
        if (!deliveryLocation.address){
            setErrors('Please enter contact person address to continue.');
            return ;
        }
       
        if (!deliveryLocation.email){
            setErrors('Please enter contact person email to continue.');
            return ;
        }
       
        if (!deliveryLocation.phone){
            setErrors('Please enter contact person phone number to continue.');
            return ;
        }

        handleLocationSetter(deliveryLocation);
    }, [deliveryLocation]);

    const handleOnChange = useCallback((e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        const fieldValue = type === "checkbox" && "checked" in e.target ? (e.target as HTMLInputElement).checked : value;
        
        setDeliveryLocation((prev) => ({ ...prev, [name]: fieldValue}));
    }, []);

    return (
        <Form className='my-4' onSubmit={handleShippingAddressSubmission}>
            {errors && <Alert style={{ fontSize: '.9rem' }} variant='danger'>{errors}</Alert>}
            <Row>
                <Col md={6} xs={12}>
                    <Form.Control 
                        type='text'
                        placeholder='First name'
                        name='firstName'
                        required
                        value={deliveryLocation.firstName}
                        onChange={handleOnChange}
                    />
                </Col>
                <Col md={6} xs={12}>
                    <Form.Control 
                        type='text'
                        placeholder='Last name'
                        name='lastName'
                        required
                        value={deliveryLocation.lastName}
                        onChange={handleOnChange}
                    />
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12}>
                    <Form.Control 
                        type='text'
                        placeholder='Address'
                        name='address'
                        required
                        value={deliveryLocation.address}
                        onChange={handleOnChange}
                    />
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={6} xs={12}>
                    <Form.Select size='sm' className='py-2' name='country' required>
                        <option value="nigeria">Nigeria</option>
                    </Form.Select>
                </Col>
                <Col md={6} xs={12}>
                    <Form.Select size='sm' value={deliveryLocation.state} className='py-2' name='state' onChange={handleOnChange} required>
                        <option>State</option>
                        {states.map((state: string, i: number) => <option key={`option-${i}`} value={state}>{state}</option>)}
                    </Form.Select>
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12}>
                    <Form.Control 
                        type='text'
                        placeholder='Email'
                        name='email'
                        required
                        value={deliveryLocation.email}
                        onChange={handleOnChange}
                    />
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12}>
                    <Form.Control 
                        type='text'
                        placeholder='Phone number'
                        name='phone'
                        required
                        value={deliveryLocation.phone}
                        onChange={handleOnChange}
                    />
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12}>
                    <Form.Select value={deliveryLocation.heading} size='sm' className='py-2' name='heading' onChange={handleOnChange} required>
                        <option value="Home">Home</option>
                        <option value="Office">Office</option>
                        <option value="Billing">Billing</option>
                        <option value="Shipping">Shipping</option>
                    </Form.Select>
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12}>
                    <Form.Check
                        inline
                        name="defaults"
                        type="checkbox"
                        label="Set as Default"
                        id={`inline-default-1`}
                        style={{ fontSize: '.9rem' }}
                        defaultChecked={deliveryLocation.defaults??true}
                        onChange={handleOnChange}
                    />
                </Col>
            </Row>
            <Row className='my-3'>
                <Col md={12} xs={12} className='d-flex justify-content-end'>
                    <Button type='button' variant='outline-danger' onClick={() => handleModal(false)} className='rounded'>Cancel</Button> &nbsp;&nbsp;
                    <Button type='submit' variant='success' className='rounded'>Save Changes</Button>
                </Col>
            </Row>
        </Form>
    )
}
